// Fetches the GLOBAL feature flag boolean map from /client/feature-flags
// and hydrates the redux slice. Called on app boot (alongside the session
// fetch) and on foreground after a long background period — the server
// caches aggressively (10s L1 / 5min DynamoDB) so re-fetches are cheap.

import { apiGet } from '../../utilities/apiClient';
import { SET_FEATURE_FLAGS, SET_FEATURE_FLAGS_LOADING } from '../constants';
import { getSessionIds } from './_sessionIds';

export const fetchFeatureFlags = () => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return;
  dispatch({ type: SET_FEATURE_FLAGS_LOADING, payload: true });
  try {
    const res = await apiGet(`/feature-flags/${accountId}/${cognitoId}`);
    const flags = res?.payload?.flags ?? {};
    dispatch({ type: SET_FEATURE_FLAGS, payload: { flags } });
  } catch {
    // Swallow — initial state already preserves current behavior (features
    // stay visible until we hear otherwise). A failed fetch leaves the
    // existing snapshot intact and lets the next foreground retry.
    dispatch({ type: SET_FEATURE_FLAGS_LOADING, payload: false });
  }
};
